import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/services/auth.service';
import { ScheduleService } from 'src/app/hr-management/services/schedule.service';
import { PatientsService } from 'src/app/patients/services/patients.service';

@Component({
  selector: 'app-shared-methods',
  templateUrl: './shared-methods.component.html',
  styleUrls: ['./shared-methods.component.css']
})
export class SharedMethodsComponent implements OnInit {
  constructor(private patientsService: PatientsService,
    private auth: AuthService) { }

  ngOnInit(): void {
  }

  getPatientDetails() {
    if (this.auth.CanAccessPatients) {
      this.patientsService.GetPatientList(0, 0,0,1).subscribe(res => {
        if (res['success']) {
          localStorage.setItem('activePatients', res['data'])
        }
      })
      this.patientsService.GetPatientList(0, 1,0,1).subscribe(res => {
        if (res['success']) {
          localStorage.setItem('archivedPatients', res['data'])
        }
      })
    }
  }

}
